export const waitFor = (n: number): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, n)
  })
